import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchBar } from '@uncinc/react-searchkit';

import './style.scss';

const SearchAllContentSearchBar = () => {
  const { t } = useTranslation();

  return (
    <SearchBar
      className="SearchAllContent__SearchBar"
      autoSearch
      title={t('searchkit.search_bar.title')}
    />
  );
};

export default SearchAllContentSearchBar;
